import styled from 'styled-components';
import { P, PExtraSmall } from '../elements/Text';
import { Input } from '../elements/Input';

export const FormLabel = styled(P)`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
`;

export const FormInfo = styled(PExtraSmall)`
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 0;
`;

export const FormInput = styled(Input)`
  margin-top: 8px;
`;
